/**
 * @file 请求封装
 */
 import 'isomorphic-fetch';
 import eventBus from './eventBus';
 import store from '@/vuex/store';

 let header = {
     'Accept': 'application/json',
     'x-requested-with': 'fetch',
     'Content-Type': 'application/json;charset=utf-8'

 };

 function goToLogin() {
     eventBus.$emit('skipPage');
 }

 export default function request(params) {
     // token
     const token = store.state.env.userInfo.token;
     if(token) {
        header['token'] = token;
     }

     let reqheader = {
         method: params.method,
         headers: header,
         credentials: 'include' // 支持携带cookie
     };

     const showMsg = params['x-message'] === false ? false : true;
     // 处理get请求中的参数
     // let url = formUrl(params.url);
     let url = params.url;
     url += `?d=${+new Date()}`;

     if (params.method === 'get') {
         for (let i in params.params) {
             url += `&${i}=${params.params[i]}`;
         }
     }

     if (params.method !== 'get') {
        //  reqheader.body = contentType ? obj2Params(params.params).params.join('&') : JSON.stringify(params.params);
         reqheader.body = JSON.stringify(params.params);
     }
     return new Promise((resolve, reject) => {
         fetch(url, reqheader).then(response => {
             if (response.status !== 200) {
                 showMsg && eventBus.$emit('requestError', '网络异常，请重试');
                 return reject(response);
             }
             return response.json();
         }).then(data => {
             switch (parseInt(data.code, 10)) {
                 case 703:
                     goToLogin();
                     break;
                 case 710:
                     goToLogin();
                     break;
             case 200:
                     break;
                 case 0:
                     break;
                 default:
                     showMsg && eventBus.$emit('requestError', data.msg || '网络异常，请重试');
                     showMsg && reject();
             }
             resolve(data);
         }).catch(error => {
             reject(error);
         });
     });
 }
